<template lang="pug">
    div.account
        el-dialog(
            title="账号设置"
            :visible.sync="accountSettingData.show"
            :close-on-click-modal="false"
            width="558px"
            center
        )
            el-form.form(
                :model="accountForm"
                :rules="rules"
                ref="accountForm"
                label-width="70px"
            )
                el-form-item(
                    prop="phone"
                    label="手机号："
                )
                    el-input(
                        v-model="accountSettingData.phone"
                        style="width: 400px"
                        disabled
                    )
                el-form-item(
                    prop="username"
                    label="用户名："
                )
                    el-input(
                        v-model="accountSettingData.username"
                        style="width: 400px"
                        disabled
                    )
                el-form-item.nameClass(
                    prop="name"
                    label="姓名："
                )
                    el-input(
                        v-model="accountForm.name"
                        style="width: 400px"
                        maxlength="20"
                        :disabled="accountSettingData.userCategory !== 'EXTERNAL'"
                    )
                el-form-item(
                    prop="org"
                    label="角色："
                )
                    el-select(
                        v-model="userRoles"
                        style="width: 400px"
                        disabled
                        multiple
                    )
                        el-option(
                            v-for="(item, index) in accountSettingData.roles"
                            :key="index"
                            :value="item.roleId"
                            :label="item.roleName"
                        )
            span(
                    slot="footer"
                )
                el-button(
                    style="width: 110px"
                    @click="close"
                    size="small"
                    round
                ) 取消
                el-button(
                    style="width: 110px"
                    @click="handleSubmit"
                    type="primary"
                    size="small"
                    round
                ) 提交
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
    loginApis,
} from '@/api';

export default {
    name: 'AccountSetting',
    props: {
        accountSettingData: {
            type: Object,
            default: () => ({
                userId: 0,
                show: true,
                roles: [],
                name: '',
                username: '',
                userCategory: '',
                phone: '',
            }),
        },
    },
    data() {
        return {
            accountForm: {
                name: '',
            },
            userRoles: [],
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入姓名',
                        trigger: 'blur',
                    },
                ],
            },
        };
    },
    mounted() {
        this.accountForm.name = this.accountSettingData.name;
        this.userRoles = this.accountSettingData.roles.map(val => val.roleId);
    },
    computed: {
        ...mapState('user', [
            'userInfo',
        ]),
    },
    methods: {
        ...mapActions('user', [
            'resetUserInfo',
        ]),
        handleSubmit() {
            if (this.accountSettingData.userCategory !== 'EXTERNAL') {
                this.accountSettingData.show = false;
                return;
            }
            this.$refs.accountForm.validate(async (valid) => {
                if (!valid) return;
                try {
                    await loginApis.modifyName({
                        name: this.accountForm.name,
                        id: this.accountSettingData.userId,
                    });
                    const userInfo = {
                        ...this.userInfo,
                        name: this.accountForm.name,
                    };
                    this.resetUserInfo(userInfo);
                    this.$message({
                        message: '账号设置修改成功',
                        type: 'success',
                    });
                    this.accountSettingData.show = false;
                    this.$bus.$emit('UserManageHome-refresh');
                    // window.location.reload();
                } catch (err) {
                    throw new Error(err);
                }
            });
        },
        close() {
            this.accountSettingData.show = false;
        },
    },
};
</script>

<style lang="scss">
    .account {
        .nameClass {
            .el-form-item__label {
                margin-left: -10px;
            }
        }
        .el-dialog__footer {
            padding-top: 0;
        }
        .el-dialog .el-dialog__body {
            padding: 20px 30px 0 30px;
        }
    }
</style>
